import React, { useEffect, useState }    from 'react';
import ExpandMoreIcon         from '@mui/icons-material/ExpandMore';
import SendEmail              from './SendEmail';
import SendAvviso             from './SendAvviso';
import { Close, Edit }        from '@mui/icons-material';
import { useTranslation }     from 'react-i18next';
import dayjs                  from 'dayjs';
import CustomDatePickerFilter from './fields/CustomDatePickerFilter';
import ContactMailIcon        from '@mui/icons-material/ContactMail'; //icona per il modale di inserimento indirizzo per ritiro RMA
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Collapse,
  Box,
  Typography,
  Stepper,
  Step,
  StepLabel,
  TextField,
  Button,
  Skeleton,
  Snackbar,
  Alert,
  Tooltip
} from '@mui/material';
import ClienteEditModal from './modal/ClienteEditModal';
import RitiroClienteModal from './modal/RitiroClienteModal';




const TabellaRMAClienti = ({ data, loading, steps, filtri, setFiltri, dynamicSteps, customStepIcon, updateCard }) => {

  const { t } = useTranslation();

  const [openRows,                setOpenRows               ] = useState({});
  const [openSnackbar,            setOpenSnackbar           ] = useState(false);
  const [message,                 setMessage                ] = useState('');
  const [snackbarSeverity,        setSnackbarSeverity       ] = useState('success');
  const [filtriAttivi,            setFiltriAttivi           ] = useState(false);
  const [isModalOpen,             setIsModalOpen            ] = useState(false);
  const [isEditable,              setIsEditable             ] = useState(false);
  const [editableRow,             setEditableRow            ] = useState(null);
  const [isModalIndirizzoOpen,    setIsModalIndirizzoOpen   ] = useState(false);
  const [addIndirizzoRow,         setAddIndirizzoRow        ] = useState(null);


  useEffect(() => {
    const hasRichiestaIntegrazione = data.some((row) => row.richiestaIntegrazione === true);
    setIsEditable(hasRichiestaIntegrazione);
  }, [data]);
  
  


  const handleRowToggle = (id) => {
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleInputChange = (field, value) => {
    setFiltri((prevFiltri) => ({
      ...prevFiltri,
      [field]: value,
    }));
  };

  const handleClick = (row) => {
    const idReso          = row.idReso;
    const destinatario    = null;
    const idDestinatario  = 1;
    const messaggio       = null;

    // Invio email
    // SendEmail(
    //   idReso,
    //   destinatario,
    //   messaggio,
    //   'AGGIORNAMENTO_DAL_CLIENTE',
      
    //   () => {
    //     setMessage(t('Email inviata con successo! vi contatteremo al più presto!'));
    //     setSnackbarSeverity('success');
    //     setOpenSnackbar(true);
    //   },
    //   () => {
    //     setMessage(t("Errore nell'invio dell'email. Per favore, riprova."));
    //     setSnackbarSeverity('error');
    //     setOpenSnackbar(true);
        
    //   }
    // );

    // Invio avviso
    SendAvviso(
      idReso,
      idDestinatario,
      'AVVISO',
      () => {
        setMessage(t('Avviso inviato con successo! vi contatteremo al più presto!'));
        setSnackbarSeverity('success');
        setOpenSnackbar(true);
      },
      () => {
        setMessage(t("Errore nell'invio dell'avviso. Per favore, riprova."));
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
      }
    );
  };


  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };


  const handleToggleFiltri = () => {
    setFiltriAttivi(!filtriAttivi);

    if (filtriAttivi) {
      setFiltri({
        idReso:           '',
        numeroFattura:    '',
        data:             '',
        stato:            '',
        descrizione:      ''
      });
    }
  };

  const getStatoColor = (stato) => {
    switch (stato) {
      case 'IN_ATTESA':
        return 'gray';
      case 'IN_LAVORAZIONE':
        return 'blue';
      case 'ACCETTATO_INVIO_CLIENTE':
        return 'lightgreen';
      case 'ACCETTATO_ATTESA_INFO_RITIRO':
        return 'darkgreen';
      case 'ACCETTATO':
        return 'green';
      case 'RIFIUTATO':
        return 'red';
      case 'RINVIATO':
        return 'orange';
      case 'RIMBORSATO':
        return 'purple';
      default:
        return 'black';
    }
  };

  const getStepIndex = (stato) => {
    switch (stato) {
        case 'IN_ATTESA':
            return 0;
        case 'IN_LAVORAZIONE':
            return 1;
        case 'ACCETTATO_INVIO_CLIENTE':
        case 'ACCETTATO_ATTESA_INFO_RITIRO':
            return 2;
        case 'ACCETTATO':
        case 'RIFIUTATO':
        case 'RINVIATO':
            return 3;
        case 'RIMBORSATO':
            return 4;
        default:
            return 0;
    }
};

  const filteredData = data.filter((row) => {
    const matchIdReso = !filtri.idReso || row.idReso?.toString().includes(filtri.idReso);
    const matchNumeroFattura = !filtri.numeroFattura || row.numeroFattura.toString().startsWith(filtri.numeroFattura);

    const matchData =
      !filtri.data ||
      (dayjs(row.dataFattura).isSame(dayjs(filtri.data))) ||
      (dayjs(row.dataRicezioneMerce).isSame(dayjs(filtri.data)));

    const formattedStato = row.stato?.toLowerCase().replace(/_/g, ' ');
    const matchStato = !filtri.stato || formattedStato?.includes(filtri.stato.toLowerCase());

    const matchDescrizione = !filtri.descrizione || row.descrizione?.toLowerCase().includes(filtri.descrizione.toLowerCase());

    return (
      matchIdReso &&
      matchNumeroFattura &&
      matchData &&
      matchStato &&
      matchDescrizione
    );
  });

  const handleEditRMA = (row) => {
    setEditableRow(row);
    setIsModalOpen(true);
};

const handleAddIndirizzoModal = (row) => {
  setAddIndirizzoRow(row);
  setIsModalIndirizzoOpen(true);
};


const renderFilterField = (field, placeholder) => (
  <TextField
    variant="standard"
    placeholder={placeholder}
    size="small"
    value={filtri[field]}
    onChange={(e) => handleInputChange(field, e.target.value)}
    sx={{
      "& .MuiInput-input": {
        padding: "16px 0px",
      },
      "& .MuiInput-underline:before": {
        borderBottom: "1px solid #fda03d",
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottom: "2px solid #fda03d",
      },
      "& .MuiInput-underline:after": {
        borderBottom: "2px solid #fda03d",
      },
    }}
  />
);

const renderCustomDatePicker = (field, label) => (
  <CustomDatePickerFilter
    name={field}
    label={label}
    onDateChange={(value) => handleInputChange(field, value)}
    values={filtri[field]}
    minDate="2020/01/01"
  />
);

const renderColumnTitle = (title) => (
  <Typography variant="body2" sx={{ fontWeight: "bold", color: "#FDA03D" }}>
    {title}
  </Typography>
);


const handleCloseModal = () => {
  setEditableRow(null); 
  setIsModalOpen(false); 
};

const handleCloseIndirizzoModal = () => {
  setIsModalIndirizzoOpen(false);
  setAddIndirizzoRow(null);
};


return (
  <>
    <TableContainer
      sx={{
        borderRadius: '20px',
        border: 'solid 1px #e0e0e0',
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
        m: 4,
        width: 'auto',
        height: '60vh',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          display: 'none', // Chrome, Safari, Opera
        },
        'msOverflowStyle:': 'none',  // IE e Edge
        'scrollbarWidth': 'none',  // Firefox
      }}
    >
      <Table>
        <TableHead
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 1000,
            background: "#fff",
          }}
        >
          <TableRow>
            <TableCell>{filtriAttivi ? renderFilterField('idReso', t('ID Reso')) : renderColumnTitle(t('ID Reso'))}</TableCell>
            <TableCell>{filtriAttivi ? renderFilterField('numeroFattura', t('N. Fattura')) : renderColumnTitle(t('N. Fattura'))}</TableCell>
            <TableCell>{filtriAttivi ? renderCustomDatePicker('data', t('Data')) : renderColumnTitle(t('Data'))}</TableCell>
            <TableCell>{filtriAttivi ? renderFilterField('stato', t('Stato')) : renderColumnTitle(t('Stato'))}</TableCell>
            <TableCell>{filtriAttivi ? renderFilterField('descrizione', t('Descrizione')) : renderColumnTitle(t('Descrizione'))}</TableCell>
            <TableCell sx={{ fontWeight: 'bold', color: '#FDA03D' }}>{t('Aggiornamenti')}</TableCell>
            <TableCell>
              <Button
                onClick={handleToggleFiltri}
                sx={{
                  width: '100%',
                  borderRadius: '10px',
                  bgcolor: '#FDA03D',
                  color: 'white',
                  fontWeight: 'bold',
                  height: '30px',
                  '&:hover': {
                    bgcolor: '#FDA03D',
                    color: 'white',
                    transform: 'scale(1.02)'
                  }
                }}
              >
                {filtriAttivi ? <Close sx={{ minWidth: 0, px: 5 }} /> : t('Filtra')}
              </Button>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            Array.from(new Array(5)).map((_, index) => (
              <TableRow key={index}>
                <TableCell><Skeleton variant="text" /></TableCell>
                <TableCell><Skeleton variant="text" /></TableCell>
                <TableCell><Skeleton variant="text" /></TableCell>
                <TableCell><Skeleton variant="text" /></TableCell>
                <TableCell><Skeleton variant="text" /></TableCell>
                <TableCell><Skeleton variant="rectangular" width={100} height={40} /></TableCell>
                <TableCell><Skeleton variant="text" /></TableCell>
              </TableRow>
            ))
          ) : filteredData.length === 0 ? (
            <TableRow>
              <TableCell colSpan={7}>
                <Typography variant="h6" align="center" fontSize={15}>
                  {t('Non hai resi da visualizzare')}
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            filteredData.map((row) => {
              const editable = row.richiestaIntegrazione === true; 
              const addIndirizzo = row.richiestaIndirizzo === true;
              return (
                <React.Fragment key={row.id}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', color: 'grey' }}>{row.idReso}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: 'grey' }}>{row.numeroFattura}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: 'grey' }}>
                      {row.dataFattura ? row.dataFattura : row.dataRicezioneMerce}
                    </TableCell>
                    <TableCell>
                      <span style={{ color: getStatoColor(row.stato), fontWeight: 'bold' }}>
                        {/* {row.stato.replace(/_/g, ' ')} */}
                        {t(`${row?.stato}`)}
                      </span>
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: 'grey' }}>{row.descrizione}</TableCell>
                    <TableCell>
                      <Button
                        onClick={() => handleClick(row)}
                        variant="outlined"
                        size="small"
                        sx={{
                          border: '1px solid #28334B',
                          color: '#28334B',
                          fontWeight: 'bold',
                          borderRadius: '40px',
                          '&:hover': {
                            bgcolor: '#28334B',
                            color: 'white',
                            transform: 'scale(1.02)',
                          },
                        }}
                      >
                        {t('OTTIENI AGGIORNAMENTO')}
                      </Button>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        {editable && ( // Mostra l'icona di modifica solo se richiestaIntegrazione è true
                          <Tooltip title={t('Modifica')}>
                            <IconButton onClick={() => handleEditRMA(row)}>
                              <Edit />
                            </IconButton>
                          </Tooltip>
                        )}
                        {addIndirizzo && ( //mostra l'icona per inserire l'indirizzo solo se richiestaIndirizo è true
                        <Tooltip title={t('Inserisci indirizzo ritiro')}>
                            <IconButton onClick={() => handleAddIndirizzoModal(row)}>
                            <ContactMailIcon />
                          </IconButton>
                        </Tooltip>
                        )}
                        <IconButton onClick={() => handleRowToggle(row.id)}>
                          <ExpandMoreIcon />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                      <Collapse in={openRows[row.id]} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                          <Typography variant="h6" gutterBottom component="div" sx={{ fontWeight: 'bold', color: '#263F78' }}>
                            {t('Dettagli Reso')}
                          </Typography>
                          <Stepper activeStep={getStepIndex(row.stato)} alternativeLabel>
                            {steps.map((step, index) => (
                              <Step key={index}>
                                <StepLabel StepIconComponent={customStepIcon(row.stato)}>
                                  {dynamicSteps(step, index, row.stato)}
                                </StepLabel>
                              </Step>
                            ))}
                          </Stepper>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>

    {/* Modale per modificare i dati */}
    {editableRow && (
      <ClienteEditModal
        open={isModalOpen}
        onClose={handleCloseModal}
        selectedRMA={editableRow} 
      />
    )}

    {/* Modale per inserimento indirizzo ritiro pacco */}
    {addIndirizzoRow && (
      <RitiroClienteModal
        open={isModalIndirizzoOpen}
        onClose={handleCloseIndirizzoModal}
      />
    )}

    <Snackbar
      open={openSnackbar}
      autoHideDuration={6000}
      onClose={handleCloseSnackbar}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  </>
);
};

export default TabellaRMAClienti;
